import PrimaryContactModule from './PrimaryContact.module';

export default PrimaryContactModule;
